import { put, takeEvery } from 'redux-saga/effects'
import { FETCH_CLIENTS, FETCHING_CLIENTS, CLIENTS_FETCHED } from '../actions/client'
import clientService from '../../services/client'

function * fetchClients ({ loading, currentPage, pageSize, filter, sort, searchText }) {
  try {
    yield put({ type: FETCHING_CLIENTS, loading })
    const clients = yield clientService.listByPage(currentPage, pageSize, filter, sort, searchText)
    yield put({ type: CLIENTS_FETCHED, clients, loading: false })
  } catch (e) {
    yield put({ type: FETCHING_CLIENTS, loading: false })
    console.error(e)
  }
}

function * watchClient () {
  yield takeEvery(FETCH_CLIENTS, fetchClients)
}

export default watchClient
